import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { Link } from 'react-router-dom';

export default function PurchaseHelpModal({ show, onCloseModal, title, timer, onStayLoggedIn, onLogout }) {
    return (
        <Modal
            className="rounded-lg"
            show={show}
            onHide={onCloseModal}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="md"
        >
            <Modal.Header closeButton className="d-flex justify-content-center border-0">
                {/* <Modal.Title as="h5" className="mb-0">{'title'}</Modal.Title> */}
            </Modal.Header>
            <Modal.Body className="px-4 pb-4">
                <div className='row p-3'>
                    {/* <div className='col-12'><i className="ri-information-line"></i></div> */}
                    <div className='col-12'>
                        <p className='mb-2'>You have already purchased this offering and currently this is active for your account. Click on <strong>View Orders</strong> to view your active orders.</p>
                    </div>
                    <div className='col-12 text-end '>
                        <Link className='edu-btn btn-small subscribe' to={'/orders'}>View Orders</Link>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
